import { useEffect, useState } from "react";

import { IOptionGeneric } from "../../shared/interface";
import { useQuery } from "@apollo/client";
import { REASON_FOR_VISIT_V2 } from "./reason-for-visit-v2.query";
import { IReasonForVisitItemResponse, IReasonForVisitResponse } from "../reason-for-visit/reason-for-visit.interface";

export const useReasonForVisitV2 = () => {
  const [expressReasonList, setExpressReasonList] = useState<{ name: string, options: IOptionGeneric[] }[]>([]);
  const { loading, data } = useQuery<{ getReasonsForVisitV2: IReasonForVisitResponse }>(REASON_FOR_VISIT_V2);

  useEffect(() => {
    if (data) {
      setExpressReasonList(getExpressVisitReasonsMap(data.getReasonsForVisitV2.items));
    }
  }, [data]);

  return {
    loading,
    expressReasonList,
  };
};

const getExpressVisitReasonsMap = (items: IReasonForVisitItemResponse[]):
{ name: string, options: IOptionGeneric[] }[] => {
  return items.map((item) => ({
    name: item.name,
    options: item.options.map((e) => ({
      value: e,
      label: e,
    })),
  }));
};
